import { render } from "./ChatWComponent.vue?vue&type=template&id=443df722"
import script from "./ChatWComponent.vue?vue&type=script&lang=js"
export * from "./ChatWComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__